import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE,
    ATTENDANCE_LENGTH_SETTING_DESC,
    ATTENDANCE_LENGTH_SETTING_TEXT,
    COUNTDOWN_TIMER_LABEL, DEFAULT_COUNT_DOWN_TIME_LIMIT,
    DEFAULT_POLL_BREAK_TIME_LIMIT,
    PARTICIPANT_TIME_INTRO,
    POLL_BREAK_DURATION_LABEL,
    POLL_COUNTDOWN_TIMER_DESCRIPTION, POLL_END_FLEXIBLE_TIME_DESCRIPTION,
    POLL_LENGTH_SETTING_DESC,
    POLL_LENGTH_SETTING_TEXT, POLL_TEXT, POLL_TIME_LIMIT_TEXT,
    POLL_TYPE, PPT_AUTO_SHARE_ATTENDANCE_DESCRIPTION,
    PPT_AUTO_SHARE_DESCRIPTION,
    PPT_AUTO_SHARE_TITLE,
    SHOW_CORRECT_ANSWER,
    SHOW_CORRECT_ANSWER_DESCRIPTION,
    USER_SETTINGS
} from "../../utils/constants";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import React, {useState} from "react";
import {YuJaToggle} from "../../components/standardization/YuJaToggle";
import {deCapitalizeWord} from "../../utils/helpers";
import {
    MINIMUM_COUNT_DOWN_SETTING_ERROR,
    MINIMUM_POLL_BREAK_DURATION_SETTING_ERROR,
} from "../../utils/toast-message-constants";
import classes from "./ActivityEditor.module.css";
import TimeLimitInput from "../../components/TimeLimitInput";

export default function ActivityEditorConfigurationSectionA({draftActivity, setDraftActivity, userSettings, hasReleased}) {
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};

    return (
        <div className={classes.settingsGridLayout}>
            {/*get ready time limit*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{COUNTDOWN_TIMER_LABEL}</div>
                        <div className={settingsClasses.settingDescription}>{POLL_COUNTDOWN_TIMER_DESCRIPTION}</div>
                    </div>

                    <TimeLimitInput
                        timeLimit={draftActivity.getReadyAllTimeLimit}
                        setTimeLimit={(timeLimit) => {
                            let copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.getReadyAllTimeLimit = timeLimit;
                            setDraftActivity(copy);
                        }}
                        unit={"MM:SS"}
                        minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                        reachMinValErrorText={MINIMUM_COUNT_DOWN_SETTING_ERROR}
                    />
                </>
            }


            {/*Time Limit*/}
            {draftActivity.pollType === POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{ATTENDANCE_LENGTH_SETTING_TEXT}</div>
                        <div className={settingsClasses.settingDescription}>{ATTENDANCE_LENGTH_SETTING_DESC}</div>
                    </div>
                    <YuJaToggle
                        containerStyle={{flexShrink: 0}}
                        name={"userSettingsCloseAttendanceToggle"}
                        toggled={draftActivity.manualEnd === "true" || draftActivity.manualEnd === true}
                        onClick={(e) => {
                            const input = e.currentTarget;
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.manualEnd = input.checked;

                            if (!input.checked && !draftActivity.attendanceDuration) {
                                copy.attendanceDuration = userSettings[USER_SETTINGS.ATTENDANCE_DURATION];
                            }

                            setDraftActivity(copy);
                        }}
                    />

                    {(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&
                        <>
                            <div style={columnLayoutStyle}>
                                <span className={settingsClasses.settingLabel}>{POLL_TIME_LIMIT_TEXT}</span>
                                <span className={settingsClasses.settingDescription}>
                                    {PARTICIPANT_TIME_INTRO.replaceAll(
                                        ACTIVITY_TYPE_PLACEHOLDER,
                                        draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                            ? deCapitalizeWord(ATTENDANCE)
                                            : deCapitalizeWord(POLL_TEXT)
                                    )}
                                </span>
                            </div>

                            <TimeLimitInput
                                timeLimit={draftActivity.attendanceDuration}
                                setTimeLimit={(timeLimit) => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.attendanceDuration = timeLimit;
                                    if (!timeLimit) {
                                        copy.manualEnd = true;
                                    }
                                    setDraftActivity(copy);
                                }}
                                unit={"HH:MM"}
                            />
                        </>
                    }

                    {/*{(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&*/}
                    {/*    <div style={{...columnLayoutStyle, gridColumn: "1/-1", flexDirection: "row", gap: 5,}}>*/}
                    {/*        <span style={{marginTop: 6}}> {PARTICIPANT_TIME_INTRO}</span>*/}
                    {/*        <div style={{display: "flex", gap: "5px"}}>*/}
                    {/*            <div style={{display: "flex", flexDirection: "column"}}>*/}
                    {/*                <YuJaTextBox*/}
                    {/*                    containerStyle={{width: 50, height: 35}}*/}
                    {/*                    inputAlign={"center"}*/}
                    {/*                    value={attendanceTimeLimit.split(":")[0]}*/}
                    {/*                    onChange={handleAttendanceDurationChangeH}*/}
                    {/*                    onBlur={handleAttendanceDurationBlur}*/}
                    {/*                    placeholder={"00"}*/}
                    {/*                    type={"number"}*/}
                    {/*                />*/}
                    {/*                <div style={{fontSize: 13, fontWeight: "400", textAlign: "center"}}>{HOURS}</div>*/}
                    {/*            </div>*/}
                    {/*            <div style={{marginTop: 6}}> :</div>*/}
                    {/*            <div style={{display: "flex", flexDirection: "column"}}>*/}
                    {/*                <YuJaTextBox*/}
                    {/*                    containerStyle={{width: 50, height: 35}}*/}
                    {/*                    inputAlign={"center"}*/}
                    {/*                    value={attendanceTimeLimit.split(":")[1]}*/}
                    {/*                    onChange={handleAttendanceDurationChangeM}*/}
                    {/*                    onBlur={handleAttendanceDurationBlur}*/}
                    {/*                    placeholder={"00"}*/}
                    {/*                    type={"number"}*/}
                    {/*                />*/}
                    {/*                <div style={{fontSize: 13, fontWeight: "400", textAlign: "center"}}>{MINUTES}</div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        {ATTENDANCE_LENGTH_SETTING_DESCRIPTION.split(" ").map((word, index) =>*/}
                    {/*            <span key={index} style={{marginTop: 6}}> {word} </span>*/}
                    {/*        )}*/}

                    {/*    </div>*/}
                    {/*}*/}
                </>
            }

            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{POLL_LENGTH_SETTING_TEXT}</div>
                        <div className={settingsClasses.settingDescription}>{POLL_LENGTH_SETTING_DESC}</div>
                    </div>
                    <YuJaToggle
                        containerStyle={{flexShrink: 0}}
                        name={"userSettingsCloseAttendanceToggle"}
                        toggled={draftActivity.manualEnd === "true" || draftActivity.manualEnd === true}
                        onClick={(e) => {
                            const input = e.currentTarget;
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.manualEnd = input.checked;
                            if (!input.checked && !draftActivity.pollTimeLimit) {
                                copy.pollTimeLimit = userSettings[USER_SETTINGS.POLL_DURATION];
                            }
                            setDraftActivity(copy);
                        }}
                    />

                    {(draftActivity.manualEnd === "false" || draftActivity.manualEnd === false) &&
                        <>
                            <div style={columnLayoutStyle}>
                                <span className={settingsClasses.settingLabel}>{POLL_TIME_LIMIT_TEXT}</span>
                                <span className={settingsClasses.settingDescription}>
                                    {PARTICIPANT_TIME_INTRO.replaceAll(
                                        ACTIVITY_TYPE_PLACEHOLDER,
                                        draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                            ? deCapitalizeWord(ATTENDANCE)
                                            : deCapitalizeWord(POLL_TEXT)
                                    )}
                                </span>
                            </div>

                            <TimeLimitInput
                                timeLimit={draftActivity.pollTimeLimit}
                                setTimeLimit={(timeLimit) => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.pollTimeLimit = timeLimit;
                                    if (!timeLimit) {
                                        copy.manualEnd = true;
                                    }
                                    setDraftActivity(copy);
                                }}
                                unit={"HH:MM"}
                            />
                        </>
                    }

                </>
            }

            {/*   Poll End Countdown */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <span className={settingsClasses.settingLabel}>{POLL_BREAK_DURATION_LABEL}</span>
                        <span className={settingsClasses.settingDescription}>
                            {POLL_END_FLEXIBLE_TIME_DESCRIPTION.replaceAll(ACTIVITY_TYPE_PLACEHOLDER, deCapitalizeWord(POLL_TEXT))}
                        </span>
                    </div>

                    <TimeLimitInput
                        timeLimit={draftActivity.pollBreakDuration}
                        setTimeLimit={(timeLimit) => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.pollBreakDuration = timeLimit;
                            setDraftActivity(copy);
                        }}
                        minVal={DEFAULT_POLL_BREAK_TIME_LIMIT}
                        reachMinValErrorText={MINIMUM_POLL_BREAK_DURATION_SETTING_ERROR}
                        unit={"MM:SS"}
                    />
                </>
            }

            {/*show correct answer*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{SHOW_CORRECT_ANSWER}</div>
                        <div className={settingsClasses.settingDescription}>{SHOW_CORRECT_ANSWER_DESCRIPTION}</div>
                    </div>

                    <YuJaToggle
                        containerStyle={{flexShrink: 0}}
                        name={"userSettingsShowCorrectAnswerToggle"}
                        toggled={draftActivity.showAnswerOnViewer === "true" || draftActivity.showAnswerOnViewer === true}
                        onClick={(e) => {
                            const input = e.currentTarget;
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy.showAnswerOnViewer = input.checked;
                            setDraftActivity(copy);
                        }}
                    />
                </>
            }

            {/*   PPT Auto Share */}
            <div>
                <div className={settingsClasses.settingLabel}> {PPT_AUTO_SHARE_TITLE} </div>
                <div className={settingsClasses.settingDescription}>
                    {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? PPT_AUTO_SHARE_ATTENDANCE_DESCRIPTION
                        : PPT_AUTO_SHARE_DESCRIPTION
                    }
                </div>
            </div>

            <YuJaToggle
                name={"userSettingsAutoSharePresentationToggle"}
                toggled={draftActivity.pptAutoShare === "true" || draftActivity.pptAutoShare === true}
                onClick={(e) => {
                    const input = e.currentTarget;
                    const copy = JSON.parse(JSON.stringify(draftActivity));
                    copy.pptAutoShare = input.checked;
                    setDraftActivity(copy);
                }}
            />



        </div>
    );
}